import { v4 as uuidv4 } from 'uuid';

/**
 * @description Generates a UUID string that can be used as value for key prop
 * of a component from a list.
 */
const generateUniqueKey = () => {
  return uuidv4();
};

/** Error thrown by services; `reason` is the backend's machine-readable code. */
type ServiceError = Error & { reason?: string };

/**
 * @description Helper to extract error message.
 */
const handleServiceError = (error: any, serviceName: string): never => {
  let message = 'Unknown error';
  if (error?.response?.status === 404) {
    message = `${serviceName.toUpperCase()} not found`;
  } else if (error?.response?.data?.message) {
    message = error.response.data.message;
  } else if (error?.message) {
    message = error.message;
  } else if (typeof error === 'string') {
    message = error;
  }
  const serviceError: ServiceError = new Error(message);
  serviceError.reason = error?.response?.data?.reason;
  throw serviceError;
};

export { generateUniqueKey, handleServiceError };
